if (!customElements.get('l20-active-content-tab')) {
  class L20ActiveContentTab extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-content-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-content-panel]'));
      if (this.tabs.length !== 2 || this.panels.length !== 2) return;

      this.handleClick = (event) => this.activate(Number(event.currentTarget.dataset.contentTab));
      this.handleKeydown = (event) => this.onKeydown(event);
      this.handleBlockSelect = (event) => this.onBlockSelect(event);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleClick);
        tab.addEventListener('keydown', this.handleKeydown);
      });
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.activate(0, false);
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleClick);
        tab.removeEventListener('keydown', this.handleKeydown);
      });
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    activate(index, focus = false) {
      if (!Number.isInteger(index) || index < 0 || index >= this.tabs.length) return;
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (focus) this.tabs[index].focus();
    }

    onKeydown(event) {
      const index = Number(event.currentTarget.dataset.contentTab);
      let nextIndex = index;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % 2;
      else if (event.key === 'ArrowLeft') nextIndex = (index + 1) % 2;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = 1;
      else return;
      event.preventDefault();
      this.activate(nextIndex, true);
    }

    onBlockSelect(event) {
      const panel = event.target.closest('[data-content-panel]');
      if (panel) this.activate(Number(panel.dataset.contentPanel));
    }
  }

  customElements.define('l20-active-content-tab', L20ActiveContentTab);
}
